export default {
      id: "hourglass-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#hourglass",
      toString: function () {
        return this.url;
      }
    }